import { render, staticRenderFns } from "./VerifyCode.vue?vue&type=template&id=ba4fca1a&scoped=true&"
import script from "./VerifyCode.vue?vue&type=script&lang=js&"
export * from "./VerifyCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4fca1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\shop-admin-vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba4fca1a')) {
      api.createRecord('ba4fca1a', component.options)
    } else {
      api.reload('ba4fca1a', component.options)
    }
    module.hot.accept("./VerifyCode.vue?vue&type=template&id=ba4fca1a&scoped=true&", function () {
      api.rerender('ba4fca1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/VerifyCode.vue"
export default component.exports